'use strict';

var _ = require('lodash');
var UserManagementDefaultRoleViewTransformerFactory = function UserManagementDefaultRoleViewTransformerFactory(DataTransformer, applicationManagementService) {
  function UserManagementDefaultRoleViewTransformerFactory() {
    DataTransformer.call(this);
    this.sourceType = 'user-management-default-role-view-mode';
  }
  UserManagementDefaultRoleViewTransformerFactory.prototype = Object.create(DataTransformer.prototype);
  UserManagementDefaultRoleViewTransformerFactory.constructor = UserManagementDefaultRoleViewTransformerFactory;
  UserManagementDefaultRoleViewTransformerFactory.prototype.canTransform = function (sourceType) {
    return this.sourceType === sourceType;
  };
  UserManagementDefaultRoleViewTransformerFactory.prototype.isCacheable = function () {
    return false;
  };
  UserManagementDefaultRoleViewTransformerFactory.prototype.getCacheKey = function () {
    return this.sourceType;
  };
  UserManagementDefaultRoleViewTransformerFactory.prototype.transform = function (data) {
    var results = [];
    var componentApiMap = data.domain.hepList[0].properties.componentApiMap;
    if (componentApiMap) {
      _.transform(componentApiMap, function (result, item) {
        if (!applicationManagementService.isApplicationEnabled(item.application)) {
          return true;
        }
        var newEntity = {
          category: item.category,
          description: item.description,
          information: item.information,
          isViewable: false,
          isEditable: false,
          editable: !(item.essential || false),
          component: item.component
        };
        newEntity.isViewable = item.essential && true;
        result.push(newEntity);
      }, results);
      results = _.filter(results, function (result) {
        return !result.editable;
      });
    }
    return results;
  };
  return UserManagementDefaultRoleViewTransformerFactory;
};
UserManagementDefaultRoleViewTransformerFactory.$inject = ['DataTransformerFactory', 'ApplicationManagementService'];
module.exports = UserManagementDefaultRoleViewTransformerFactory;